import { useEffect } from 'react';
import computeClassName from '../../../utils/computeClassName';
import getFormattedUsernameAndInitials from '../../../utils/getFormattedUsernameAndInitials';
import { useScreenContext } from "../ContextProvider/Screen";
import { useUserContext } from '../ContextProvider/User';
import useToggle from '../../../hooks/ui/useToggle';
import UtilityBar from './UtilityBar';
import NavigationBar from './NavigationBar';
import MobileMenu from "./NavigationBar/MobileMenu";

const constants = Object.freeze({
  CLASSNAME_BASE: 'relative shadow-cc-main-content z-40'
});

export default function MasterHeader({className = ''}) {
  const computedClassName=computeClassName(className, constants.CLASSNAME_BASE);
  const { user } = useUserContext();
  const userId = user.getId();
  const isLoggedInUser = user.isLoggedIn();
  const formattedUsernameAndInitials =
    isLoggedInUser ?
      getFormattedUsernameAndInitials(user.getName()) : { name: '', initials: '' };
  const mobileMenuToggleHook = useToggle();
  const userMenuToggleHook = useToggle();
  const languageMenuToggleHook = useToggle();
  const { isScreenSMAndUp } = useScreenContext();

  useEffect(
    ()=>{
      if(isScreenSMAndUp && mobileMenuToggleHook.isToggleOn()) { mobileMenuToggleHook.toggle() }
    },
    [isScreenSMAndUp]
  );

  return (
    <header className={computedClassName}>
      <UtilityBar isLoggedInUser={isLoggedInUser}
                  userId={userId}
                  userName={formattedUsernameAndInitials.name}
                  isUserMenuOpened={userMenuToggleHook.isToggleOn()}
                  toggleUserMenuFn={userMenuToggleHook.toggle}
                  toggleOffUserMenuFn={userMenuToggleHook.toggleOff}
                  isLanguageMenuOpened={languageMenuToggleHook.isToggleOn()}
                  toggleLanguageMenuFn={languageMenuToggleHook.toggle}
                  toggleOffLanguageMenuFn={languageMenuToggleHook.toggleOff}/>
      <NavigationBar isLoggedInUser={isLoggedInUser}
                     userId={userId}
                     userInitials={formattedUsernameAndInitials.initials}
                     isUserMenuOpened={userMenuToggleHook.isToggleOn()}
                     toggleUserMenuFn={userMenuToggleHook.toggle}
                     toggleOffUserMenuFn={userMenuToggleHook.toggleOff}
                     isMobileMenuOpened={mobileMenuToggleHook.isToggleOn()}
                     toggleMobileMenuFn={mobileMenuToggleHook.toggle}
                     isLanguageMenuOpened={languageMenuToggleHook.isToggleOn()}
                     toggleLanguageMenuFn={languageMenuToggleHook.toggle}
                     toggleOffLanguageMenuFn={languageMenuToggleHook.toggleOff}/>
      {
        mobileMenuToggleHook.isToggleOn() &&
        <MobileMenu className="absolute top-full w-full"/>
      }
    </header>
  );
}
//
